import { WBFlex, WBTypography } from '@admiin-com/ds-web';
import { WBBox } from '@admiin-com/ds-web';
import { useTheme } from '@mui/material';
import { InputLabel } from '@mui/material';

export const TextFormField = ({
  label,
  value,
  icon,
  multiline = false,
}: {
  icon?: React.ReactNode;
  label: string;
  value: string;
  multiline?: boolean;
}) => {
  const theme = useTheme();
  return (
    <WBBox width="100%" maxWidth="100%">
      <InputLabel>{label}</InputLabel>
      <WBFlex
        sx={{
          borderBottom: `2px solid ${theme.palette.divider}`,
          alignItems: 'center',
          gap: 1,
          minHeight: '36px',
          maxWidth: '100%',
        }}
      >
        {icon}
        <WBTypography
          noWrap
          sx={{
            whiteSpace: multiline ? 'normal' : 'nowrap',
          }}
        >
          {value ?? 'pdf'}
        </WBTypography>
      </WBFlex>
    </WBBox>
  );
};
